





















import { Component, Prop, Vue } from "vue-property-decorator";
import CzIcon from "./CzIcon.vue";

// Tabs fixed to the foot of the screen, always visible while scrolling; the space keeps the content uncovered.
@Component({ components: { CzIcon } })
export default class CzTabBar extends Vue {
  @Prop({ type: Array, default: () => [] }) items!: { value: string; label: string; icon: string }[];
  @Prop({ default: null }) value!: any;
}
